skrilla.service('srefService', function($state) {
    var routeFromExternalRef = function(data){
        if(data.externalReference != null && data.externalReferenceType != null) {
            switch (data.externalReferenceType.toLowerCase()) {
                case "user":
                    $state.go("userDetails", {id: data.externalReference});
                    break;
            }
        }
    }

    var go = function(location, data, event){
        if(!event || event.which === 1){
            $state.go(location, data);
        }
        else if(event.which === 2){
            window.open($state.href(location, data),'_blank');
        }
    }


    return {
        routeFromExternalRef: routeFromExternalRef,
        go: go
    };
});
